export default __webpack_public_path__ + "static/media/monitor_green.3bac3d70.svg";